/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createRoadsideAssistanceCase } from '../fn/roadside-assistance-case/create-roadside-assistance-case';
import { CreateRoadsideAssistanceCase$Params } from '../fn/roadside-assistance-case/create-roadside-assistance-case';
import { OeamtcCaseCreateRequestResponse } from '../models/oeamtc-case-create-request-response';
import { OeamtcCaseUpdateRequestResponse } from '../models/oeamtc-case-update-request-response';
import { updateRoadsideAssistanceCase } from '../fn/roadside-assistance-case/update-roadside-assistance-case';
import { UpdateRoadsideAssistanceCase$Params } from '../fn/roadside-assistance-case/update-roadside-assistance-case';
import { uploadFile } from '../fn/roadside-assistance-case/upload-file';
import { UploadFile$Params } from '../fn/roadside-assistance-case/upload-file';

@Injectable({ providedIn: 'root' })
export class RoadsideAssistanceCaseService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createRoadsideAssistanceCase()` */
  static readonly CreateRoadsideAssistanceCasePath = '/api/v1/extensions/tenants/oeamtc/cases';

  /**
   * create new roadside assistance case.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createRoadsideAssistanceCase()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRoadsideAssistanceCase$Response(params: CreateRoadsideAssistanceCase$Params, context?: HttpContext): Observable<StrictHttpResponse<OeamtcCaseCreateRequestResponse>> {
    return createRoadsideAssistanceCase(this.http, this.rootUrl, params, context);
  }

  /**
   * create new roadside assistance case.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createRoadsideAssistanceCase$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createRoadsideAssistanceCase(params: CreateRoadsideAssistanceCase$Params, context?: HttpContext): Observable<OeamtcCaseCreateRequestResponse> {
    return this.createRoadsideAssistanceCase$Response(params, context).pipe(
      map((r: StrictHttpResponse<OeamtcCaseCreateRequestResponse>): OeamtcCaseCreateRequestResponse => r.body)
    );
  }

  /** Path part for operation `updateRoadsideAssistanceCase()` */
  static readonly UpdateRoadsideAssistanceCasePath = '/api/v1/extensions/tenants/oeamtc/cases/{id}';

  /**
   * Update existing resource.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateRoadsideAssistanceCase()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRoadsideAssistanceCase$Response(params: UpdateRoadsideAssistanceCase$Params, context?: HttpContext): Observable<StrictHttpResponse<OeamtcCaseUpdateRequestResponse>> {
    return updateRoadsideAssistanceCase(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing resource.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateRoadsideAssistanceCase$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateRoadsideAssistanceCase(params: UpdateRoadsideAssistanceCase$Params, context?: HttpContext): Observable<OeamtcCaseUpdateRequestResponse> {
    return this.updateRoadsideAssistanceCase$Response(params, context).pipe(
      map((r: StrictHttpResponse<OeamtcCaseUpdateRequestResponse>): OeamtcCaseUpdateRequestResponse => r.body)
    );
  }

  /** Path part for operation `uploadFile()` */
  static readonly UploadFilePath = '/api/v1/rsa/file';

  /**
   * Upload a file.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile$Response(params: UploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return uploadFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a file.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile(params: UploadFile$Params, context?: HttpContext): Observable<void> {
    return this.uploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
